var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action, computed } from 'mobx';
export class ErrorModel {
    constructor(errorState) {
        this.validationObject = observable({ errorState: errorState });
    }
    get valid() {
        const keys = Object.keys(this.validationObject.errorState);
        for (const key in keys) {
            const currenKey = keys[key];
            if (this.validationObject.errorState[currenKey]) {
                return true;
            }
        }
        return false;
    }
    get errorState() {
        return this.validationObject.errorState;
    }
    onChange(key, error) {
        Promise.resolve(error).then(error => {
            this.validationObject.errorState[key] = error;
        });
    }
}
__decorate([
    observable
], ErrorModel.prototype, "validationObject", void 0);
__decorate([
    computed
], ErrorModel.prototype, "valid", null);
__decorate([
    computed
], ErrorModel.prototype, "errorState", null);
__decorate([
    action
], ErrorModel.prototype, "onChange", null);
